module.exports = __webpack_public_path__ + "c4668ed2440df82d3fd2f8be9d31d07d.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/font-awesome/fonts/fontawesome-webfont.ttf?v=4.0.3
 ** module id = 344
 ** module chunks = 0
 **/